let PackagesItem = [
    {
        id: 1,
        trackTitle: "Senior Day 🔥",
        trackSubtitle: "For Senior developers, CTOs and Founders",
        trackPrice: "$99",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1638894663335x177740105368993800',
    },
    {
        id: 2,
        trackTitle: "Junior Day",
        trackSubtitle: "For Junior developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Day',
        trackLink: 'https://geekle.us/ticketfree/1638894274819x992638135922065400',
    },
  ];
  
  export default PackagesItem;
  